import AgoraProvider from "./Agora";
import RouterDomProvider from "./RouterDom";
import AuthProvider from "@/context/Auth";
import SocketProvider from "@/context/Socket";
import HoneybadgerProvider from "./Honeybadger";
import { ChatRequestProvider } from "@/context/ChatRequestsContext";

export default function Providers() {
  return (
    <HoneybadgerProvider>
      <AgoraProvider>
        <AuthProvider>
          <SocketProvider>
            <ChatRequestProvider>
              <RouterDomProvider />
            </ChatRequestProvider>
          </SocketProvider>
        </AuthProvider>
      </AgoraProvider>
    </HoneybadgerProvider>
  );
}
